import { Stack } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1220px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 8px 0;
  border-bottom: 1px solid #888;
`;

export const ProfileCollectTitle = styled.p`
  color: #004e9a;
  font-size: 27px;
  //font-weight: bold;
  text-transform: uppercase;
`;

export const TitlePage = styled.div`
  margin-top: 24px;
  padding: 8px 0;
  color: #004e9a;
  font-weight: bold;
  text-align: center;
  font-size: 27px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > span {
    color: #444444;
    font-weight: normal;
    font-size: 14px;
  }

  hr {
    width: 90px;
    height: 3px;
    background-color: #d58500;
    margin: 10px 0;
    border: none;
  }
`;

export const ProfileCollectText = styled.p`
  color: #333333;
  font-size: 14px;
  font-family: 'Helvetica Neue', Roboto, sans-serif;
  //font-weight: bold;
`;

export const CustomStack = styled.div`
  max-width: 840px;
  gap: 16px;
  ${({ columnBreak = false }) =>
    columnBreak
      ? 'display: grid; grid-template-columns: 50% 50%'
      : 'display: flex; flex-direction: column'};
`;

export const StackItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > img {
    width: 80px;
  }
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  label {
    cursor: pointer;
  }

  & + & {
    margin-left: 24px;
  }
`;
